import React, { PureComponent, Fragment } from 'react';
import StandardPerformanceTable from 'wt-react/dist/components/StandardPerformance/StandardPerformanceTable.js';
import DetailsTable from 'wt-react/dist/components/StandardPerformance/DetailsTable.js';
import i18n from '../../i18n.js';
import './FundPerformance.css';

const FUND_PERFORMANCE = 'fund-performance';
const FUND_DETAILS = 'fund-details';

class FundPerformance extends PureComponent {

    static defaultProps = {
        data: null,
        params: null,
        type: FUND_PERFORMANCE,
        perfFootnote: null,
    };

    render() {

        const {
            data,
            type,
            perfFootnote,
        } = this.props;

        let tableToShow;

        // Set up the table to be shown (based on which button is chosen)
        if (data && data.length > 0) {

            switch (type) {

                case FUND_PERFORMANCE:

                    tableToShow =
                        <StandardPerformanceTable
                            data={data}
                            translationDictionary={i18n}
                            showTitle={false}
                            showCommonPeriod={true}
                            showSinceInception={false}
                            commonPeriodStart={data ? data[0].stdPerformance[0].commonPeriodNAVStart : null}
                            commonPeriodEnd={data ? data[0].stdPerformance[0].commonPeriodNAVEnd : null}
                            isPortfolio={false}
                            sidePadding={60}
                            footnote={perfFootnote ? perfFootnote : i18n.t('fundPerformanceFootnoteText')}
                            key={`${data[0].name + FUND_PERFORMANCE}`}
                            wtFundsOnly={true}
                        />;

                    break;

                case FUND_DETAILS:
                    tableToShow = <DetailsTable
                        data={data}
                        translationDictionary={i18n}
                        showTitle={false}
                        sidePadding={60}
                        footnote={i18n.t('fundDetailsFootnoteText')}
                        key={`${data[0].name + FUND_DETAILS}`}
                    />;
                    break;

                default:
                    tableToShow = null;
            }

        }

        return (

            <div className="fund-performance">

                {/* Check if there is data before showing any of the tables */}
                {data ?
                    <Fragment>
                        <div className="display-table">
                            {tableToShow}
                        </div>
                    </Fragment>

                    : null}

            </div>

        );
    }
}

export default (FundPerformance);
